<template>
  <ymap-marker
    v-if="latitude && longitude"
    :coords="[latitude, longitude]"
    :marker-id="markerKey"
    :balloon-template="balloonTemplate"
    :icon="markerIcon"
  />
</template>

<script>
  import { ymapMarker } from 'vue-yandex-maps'
  import moment from 'moment'
  import { formatIsoDateTime } from '@/util/date-time-helper'

  export default {
    name: 'AddressMarker',
    components: {
      ymapMarker,
    },
    props: {
      latitude: {
        type: [String, Number],
        default: null,
      },
      longitude: {
        type: [String, Number],
        default: null,
      },
    },
    computed: {
      markerKey () {
        return `address-${this.latitude}-${this.longitude}`
      },
      balloonTemplate () {
        return `${this.latitude}, ${this.longitude}`
      },

      markerIcon () {
        return {
          layout: 'islands#redDotIcon',
          // content: this.markerIconContent,
          // imageHref: 'https://image.flaticon.com/icons/png/512/33/33447.png',
          // imageSize: [43, 43],
          // imageOffset: [0, 0],
          // contentOffset: [0, 15],
          // contentLayout:
        }
      },
    },
  }
</script>

<style lang="scss">

</style>
